import { SectionWrapper } from "shared/Styles/Wrappers";
import styled from "styled-components";

export const Container = styled.div`
    padding: 124px 0;
    padding-bottom: ${({ paddingBottom }) => `${paddingBottom}px`} !important;
    background-color: ${({ color }) => (color ? color : "#fff")};
    color: ${({ color }) => (color ? "#fff" : "#000")};
    margin-top: -1px;
    margin-bottom: -1px;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        padding: 64px 0;
    }
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        padding: 36px 0;
    }
`;

export const Wrapper = styled(SectionWrapper)`
    text-align: ${({ align }) => align ? align : 'center'};
`;

export const Title = styled.h2`
    font-size: 6rem;
    font-weight: 800;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: 4.2rem;
        line-height: 1.1;
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.laptop_small}) {
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        font-size: 3.4rem;
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.phone_big}) and (orientation: portrait) {
        font-size: 3rem;
    }

    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet}) and (orientation: landscape) {
        font-size: 2.8rem;
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.phone_big}) and (orientation: landscape) {
        font-size: 2.4rem;
    }
`;
